import { render, staticRenderFns } from "./LS01_old.vue?vue&type=template&id=fd1abe0e&scoped=true"
import script from "./LS01_old.vue?vue&type=script&lang=js"
export * from "./LS01_old.vue?vue&type=script&lang=js"
import style0 from "./LS01_old.vue?vue&type=style&index=0&id=fd1abe0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1abe0e",
  null
  
)

export default component.exports